import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import { KeyRound, ArrowLeft } from "lucide-react";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const nav = useNavigate();
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (!token) { setError("Missing reset token. Use the link from your email."); return; }
    if (next.length < 8) { setError("Password must be at least 8 characters"); return; }
    if (next !== confirm) { setError("Passwords don't match"); return; }
    setSaving(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: next });
      setDone(true);
      setTimeout(() => nav("/login"), 1800);
    } catch (err) {
      setError(err?.response?.data?.detail || "Couldn't reset password");
    } finally { setSaving(false); }
  };

  return (
    <div className="pgm-login-bg">
      <div className="pgm-reveal" style={{ width: "100%", maxWidth: 460 }}>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "center", marginBottom: 18 }}>
          <div style={{ width: 56, height: 56, background: "var(--pgm-magenta)", display: "flex", alignItems: "center", justifyContent: "center", border: "1.5px solid var(--pgm-wine)" }}>
            <KeyRound size={26} color="var(--pgm-cream)" />
          </div>
        </div>
        <div className="pgm-card">
          <div className="pgm-micro">◆ Set a new password</div>
          <h2 className="pgm-display" style={{ fontSize: 28, marginBottom: 14 }}>Choose a strong one</h2>
          {done ? (
            <div className="pgm-callout" style={{ background: "var(--pgm-olive)", color: "var(--pgm-cream)" }} data-testid="reset-done">
              <strong>Password updated.</strong> Redirecting to sign in…
            </div>
          ) : (
            <form onSubmit={submit} style={{ display: "flex", flexDirection: "column", gap: 14 }}>
              <div><label className="pgm-label">New password (min 8 chars)</label><input type="password" className="pgm-input" value={next} onChange={(e) => setNext(e.target.value)} required autoFocus data-testid="reset-new" /></div>
              <div><label className="pgm-label">Confirm new password</label><input type="password" className="pgm-input" value={confirm} onChange={(e) => setConfirm(e.target.value)} required data-testid="reset-confirm" /></div>
              {error && <div className="pgm-callout" style={{ background: "var(--pgm-orange)", color: "var(--pgm-cream)" }} data-testid="reset-error">{error}</div>}
              <button className="pgm-btn" type="submit" disabled={saving} data-testid="reset-submit">{saving ? "Updating..." : "Update password"}</button>
              <Link to="/login" className="pgm-link" style={{ display: "inline-flex", alignItems: "center", gap: 6 }}>
                <ArrowLeft size={14} /> Back to sign in
              </Link>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
